// Support apps to show in subnav
const SUPPORT_APP_IDS = [
  '0oa1fp1348nIjjw420h8', // Enterprise Service Center
  '0oa1hfbb1iwVg4SGT0h8' // Provider Support Center
]

export {
  SUPPORT_APP_IDS
}
